import React from 'react';
import { Seo } from '../../../components/Seo';
import { CimmplePayMarkdown, splitLeadingH1 } from '../../../components/docs/CimmplePayMarkdown';

type CimmplePayDocLayoutProps = {
  seoTitle: string;
  seoDescription: string;
  markdown: string;
  heroTitle?: string;
  heroSubtitle?: string;
};

export const CimmplePayDocLayout: React.FC<CimmplePayDocLayoutProps> = ({
  seoTitle,
  seoDescription,
  markdown,
  heroTitle,
  heroSubtitle,
}) => {
  const { title: inferredTitle, body } = splitLeadingH1(markdown);
  const pageTitle = heroTitle ?? inferredTitle ?? seoTitle;

  return (
    <div className="pt-24">
      <Seo title={seoTitle} description={seoDescription} />

      <section className="pt-8 pb-10">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-display font-bold text-slate-900 dark:text-white mb-3 text-balance">
            {pageTitle}
          </h1>
          {heroSubtitle ? (
            <p className="text-lg text-slate-700 dark:text-dark-300 text-balance">{heroSubtitle}</p>
          ) : null}
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="card p-8 md:p-12 prose prose-slate dark:prose-invert max-w-none">
            <CimmplePayMarkdown markdown={body} />
          </div>
        </div>
      </section>
    </div>
  );
};
